export default "__VITE_ASSET__BaTkG$2e__"